const SIZE = 200;
const INSET = 40;
const SPAN = SIZE - 2 * INSET;
const RADIUS = 13;

/** Where the nth of `count` letters sits along side `side` (clockwise from the top). */
function position(side: number, index: number, count: number) {
  const along = INSET + (SPAN * (index + 1)) / (count + 1);
  const far = SIZE - INSET;
  if (side === 0) {
    return { x: along, y: INSET };
  }
  if (side === 1) {
    return { x: far, y: along };
  }
  if (side === 2) {
    return { x: SIZE - along, y: far };
  }
  return { x: INSET, y: SIZE - along };
}

/** A square with each side's letters on its edge — a picture of what was typed. */
export function BoxPreview({ sides }: { sides: readonly string[][] }) {
  return (
    <svg
      aria-hidden="true"
      className="mx-auto h-48 w-48 text-foreground"
      focusable="false"
      viewBox={`0 0 ${SIZE} ${SIZE}`}
    >
      <rect
        fill="none"
        height={SPAN}
        stroke="currentColor"
        strokeWidth="2"
        width={SPAN}
        x={INSET}
        y={INSET}
      />
      {sides.map((letters, side) =>
        letters.map((letter, index) => {
          const { x, y } = position(side, index, letters.length);
          return (
            <g key={`${side}-${letter}`}>
              <circle
                className="fill-card stroke-current"
                cx={x}
                cy={y}
                r={RADIUS}
                strokeWidth="1.5"
              />
              <text
                className="fill-current font-bold text-sm uppercase"
                dominantBaseline="central"
                textAnchor="middle"
                x={x}
                y={y}
              >
                {letter}
              </text>
            </g>
          );
        })
      )}
    </svg>
  );
}
